// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ez-a";
export var fulfillmentFormRail = "_ez-9";
export var headerTitleRow = "_ez-c";
export var orderDetailsWrapper = "_ez-7";
export var orderLinkTrigger = "_ez-2";
export var paymentInformationGrid = "_ez-h";
export var paymentSummaryColumn = "_ez-i";
export var shipmentContainer = "_ez-b";
export var shipmentDetailsMainPane = "_ez-8";
export var shipmentNavigationCard = "_ez-5";
export var shipmentNavigationRail = "_ez-3";
export var shipmentNavigationRailHeader = "_ez-4";
export var shipmentSummaryFact = "_ez-e";
export var shipmentSummaryGrid = "_ez-d";
export var shipmentSummaryMetadataRow = "_ez-f";
export var shipmentSummaryTags = "_ez-g";
export var shipmentWorkspace = "_ez-0";
export var shipmentWorkspaceContent = "_ez-6";
export var shipmentWorkspaceHeader = "_ez-1";